import type {
    ClientOrgBillingTransferRequest,
    ClientSchema,
} from "@common/schemas/client.schema";
import {
    Organization,
    OrganizationBillingTransferMode,
} from "@common/schemas/organization.schema";

export function getVisibleOrgBillingTransferRequest({
    organization,
    client,
}: {
    organization: Pick<Organization, "billingTransferMode"> | null;
    client: Pick<ClientSchema, "orgBillingTransferRequest">;
}): ClientOrgBillingTransferRequest | null {
    if (
        organization?.billingTransferMode !==
        OrganizationBillingTransferMode.REQUEST
    ) {
        return null;
    }

    return client.orgBillingTransferRequest;
}
